var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusInquiry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6699 6.9499C21.0299 4.7799 19.2199 2.9699 17.0499 2.3299C15.3999 1.8499 14.2599 1.8899 13.4699 2.4799C12.5199 3.1899 12.4099 4.4699 12.4099 5.3799V7.8699C12.4099 10.3299 13.5299 11.5799 15.7299 11.5799H18.5999C19.4999 11.5799 20.7899 11.4699 21.4999 10.5199C22.1099 9.7399 22.1599 8.5999 21.6699 6.9499Z",
    fill: "#98A2B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9099 13.3601C18.6499 13.0601 18.2699 12.8902 17.8799 12.8902H14.2999C12.5399 12.8902 11.1099 11.4601 11.1099 9.70015V6.12015C11.1099 5.73015 10.9399 5.35015 10.6399 5.09015C10.3499 4.83015 9.9499 4.71015 9.5699 4.76015C7.2199 5.06015 5.0599 6.35015 3.6499 8.29015C2.2299 10.2401 1.7099 12.6201 2.1599 15.0001C2.8099 18.4401 5.5599 21.1902 9.0099 21.8402C9.5599 21.9502 10.1099 22.0002 10.6599 22.0002C12.4699 22.0002 14.2199 21.4401 15.7099 20.3502C17.6499 18.9402 18.9399 16.7801 19.2399 14.4302C19.2899 14.0401 19.1699 13.6501 18.9099 13.3601Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusInquiry);
export default __webpack_public_path__ + "static/media/status_inquiry.f0c01623f4545c0a5618b1e228cc9367.svg";
export { ForwardRef as ReactComponent };